var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46513 13.3833C3.9585 11.1482 1.31746 8.00834 1.31746 5.34747C1.28023 4.77597 1.36056 4.20291 1.55349 3.66372C1.74641 3.12454 2.04783 2.6307 2.4391 2.21276C2.83036 1.79483 3.30315 1.46168 3.82822 1.23393C4.35329 1.00618 4.91946 0.888672 5.49172 0.888672C6.06398 0.888672 6.63016 1.00618 7.15523 1.23393C7.68029 1.46168 8.15308 1.79483 8.54435 2.21276C8.93561 2.6307 9.23703 3.12454 9.42996 3.66372C9.62289 4.20291 9.70322 4.77597 9.66599 5.34747C9.64826 8.00834 6.9895 11.1482 5.46513 13.3833Z",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46529 7.24531C5.09095 7.2418 4.72603 7.12751 4.41647 6.91683C4.10692 6.70615 3.86659 6.40851 3.72576 6.06138C3.58492 5.71426 3.54989 5.33318 3.62506 4.96617C3.70023 4.59915 3.88224 4.26261 4.14818 3.99893C4.41411 3.73525 4.75207 3.55622 5.11948 3.48441C5.48689 3.4126 5.86732 3.45122 6.21284 3.59538C6.55837 3.73955 6.85353 3.98283 7.06116 4.29457C7.26879 4.60631 7.37959 4.97257 7.3796 5.34722C7.37961 5.59798 7.32997 5.84626 7.23356 6.07771C7.13714 6.30916 6.99585 6.51919 6.81785 6.69568C6.63986 6.87217 6.42868 7.01161 6.19653 7.10595C5.96437 7.20028 5.71584 7.24765 5.46529 7.24531Z",
    stroke: "#333333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.66c2c5f795ce3ab0f30305f170e40448.svg";
export { ForwardRef as ReactComponent };